














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const userManager = namespace("userManager");
const roleManager = namespace("roleManager");
@Component({})
export default class add extends Vue {
  dialogVisible: boolean = false;
  loading: boolean = false;
  @Prop() editData: any = null;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  ruleForm: any = {
    roleName: "",
    roleType: "2",
    status: 1
  };
  rules: any = {
    roleName: [
      {
        required: true,
        message: "角色名不能为空"
      }
    ]
  };

  @roleManager.Action addRole;
  @roleManager.Action updateRole;

  async mounted() {
    this.editData && this.setData();
  }
  @Watch("editData")
  onEditDataChange(val) {
    console.log(val);
    if (val) {
      this.setData();
    } else {
      this.setData();
      (this as any).$refs.form.resetFields();
    }
  }
  @Watch("dialogVisible")
  onDialogVisible(val) {
    !val && (this as any).$refs.form.resetFields();
  }
  setData() {
    let { roleName = "", roleCode = "" } = this.editData || {};
    this.ruleForm = {
      roleName,
      roleCode,
      roleType: "2",
      status: 1
    };
  }

  async handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(async valid => {
      if (valid) {
        this.loading = true;
        let { roleName, roleType, status } = this.ruleForm;
        if (this.isEdit) {
          await this.updateRole({ input: this.ruleForm })
            .then(_ => {
              this.$emit("refresh", 1);
              (this as any).$refs.form.resetFields();
              this.dialogVisible = false;
              this.$message({ type: "success", message: "编辑成功" });
            })
            .finally(_ => {
              this.loading = false;
            });
        } else {
          await this.addRole({ input: { roleName, roleType, status } })
            .then(_ => {
              this.$emit("refresh", 0);
              this.dialogVisible = false;
              (this as any).$refs.form.resetFields();
              this.$message({ type: "success", message: "新增成功" });
            })
            .finally(_ => {
              this.loading = false;
            });
        }
      }
    });
  }
}
